import React, { ChangeEvent, useState } from "react";

import FormLayout from "components/form/FormLayout";
import Form from "components/form/Form";
import Input from "components/form/input/Input";
import Sheet from "components/sheet/Sheet";
import Portal from "elements/Portal";
import CheckboxBlock from "../elements/CheckboxBlock";
import { useTranslation } from "react-i18next";
interface ICustomCheckboxEdit {
  label: string;
  helpText: string;
  required: boolean;
  options: string[];
  saveInput: (label: string, helpText: string, required: boolean) => void;
  editModalOpen: boolean;
  closeEditModal: () => void;
  /** Viewable INPUT on the edit page itself. */
  children: React.ReactNode;
  hideRequired?: boolean;
}

/** Structural display wrapper containing edit modal and its state. */
export default function CustomCheckboxEdit(props: ICustomCheckboxEdit) {
  const { label, helpText, required = false, options, editModalOpen, closeEditModal, hideRequired } = props;
  const { t } = useTranslation();

  const [state, setState] = useState({
    input: "",
    array: options !== null ? options : [],
    label: label,
    helpText: helpText,
    required: required,
    columnCount: 1, // Not connected
  });

  function closeModal() {
    closeEditModal();
    setState({
      input: "",
      label: label,
      helpText: helpText,
      array: options,
      required: required,
      columnCount: 1,
    });
  }

  return (
    <div className={`input-view-wrap${required ? " required" : ""}`}>
      {props.children}

      <Portal isMounted={editModalOpen}>
        <Sheet
          open={editModalOpen}
          title={t("Checkbox")}
          onOk={() => props.saveInput(state.label, state.helpText, state.required)}
          onCancel={() => closeModal()}
          okText={t("Save")}
          size="medium"
        >
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  label={t("Label")}
                  defaultValue={label}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setState(prev => ({ ...prev, label: e.target.value }))
                  }
                  className="input-edit-action"
                />
              </FormLayout.Group>
              <FormLayout.Group>
                <Input
                  label={t("Help Text")}
                  defaultValue={helpText}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    setState(prev => ({ ...prev, helpText: e.target.value }))
                  }
                  className="input-edit-action"
                />
              </FormLayout.Group>

              {!hideRequired ? (
                <FormLayout.Group>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "18px" }}>
                    <div />
                    <CheckboxBlock
                      label={t("Required")}
                      checked={state.required}
                      onChange={() => setState(prev => ({ ...prev, required: !prev.required }))}
                    />
                  </div>
                </FormLayout.Group>
              ) : null}
            </FormLayout>
          </Form>
        </Sheet>
      </Portal>
    </div>
  );
}
